import './radio-button.css'
import React from 'react'

export const RadioButton = () => <span className="radio-button" />
